// packages/web/src/utils/sync.ts
import { lastWriteWins } from './offline.service';
import { loadQuotes, loadServices, deleteQuote, deleteService } from './offlineStorage';
import { api } from '../lib/api/client';

/**
 * NEVER use raw fetch() here. apiFetch() ensures:
 *  - Authorization: Bearer <jwt> (no Week-11 stub)
 *  - X-Tenant-Id / X-Subdomain
 *  - credentials: 'include' (cookie round-trip in dev)
 */
export async function syncOfflineData() {
  // Skip when offline
  if (typeof navigator !== 'undefined' && !navigator.onLine) return;

  // Avoid churn while user is on data-entry pages (stabilizes E2E typing)
  if (typeof window !== 'undefined') {
    const p = window.location.pathname || '';
    if (p.startsWith('/quotes/new') || p.startsWith('/services/new')) return;
  }

  // ---- Quotes ----
  const quotes = await loadQuotes();
  for (const q of quotes) {
    const payload = q.payload || q;
    try {
      await api.post('/quotes', payload);
      await deleteQuote(q.id);
    } catch (err: any) {
      if (err?.status === 409) {
        const server = err?.details || err?.data || {};
        const winner = lastWriteWins(payload, server);
        if (winner === payload || winner?.id === q.id) {
          try {
            await api.post('/quotes?force=1', payload);
            await deleteQuote(q.id);
          } catch {/* ignore secondary failure */}
        }
      } else {
        // Visible breadcrumb — but don't crash the app
        // eslint-disable-next-line no-console
        console.error('Failed syncing quote', q.id, err);
      }
    }
  }

  // ---- Services ----
  const services = await loadServices();
  for (const s of services) {
    const payload = s.payload || s;
    try {
      await api.post('/services', payload);
      await deleteService(s.id);
    } catch (err: any) {
      if (err?.status === 409) {
        const server = err?.details || err?.data || {};
        const winner = lastWriteWins(payload, server);
        if (winner === payload || winner?.id === s.id) {
          try {
            await api.post('/services?force=1', payload);
            await deleteService(s.id);
          } catch {/* ignore secondary failure */}
        }
      } else {
        // eslint-disable-next-line no-console
        console.error('Failed syncing service', s.id, err);
      }
    }
  }
}

export function startPeriodicSync(interval = 30000) {
  // kick once, then interval
  syncOfflineData();
  return typeof window !== 'undefined'
    ? window.setInterval(syncOfflineData, interval)
    : null;
}
